import type { DocumentReport } from "@/mocks/documentos";

interface DocumentReportsGridProps {
  reports: DocumentReport[];
}

export default function DocumentReportsGrid({ reports }: DocumentReportsGridProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Relatórios documentais</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {reports.map((report) => (
          <div key={report.id} className="bg-white rounded-xl border border-background-200/70 p-4 hover:shadow-sm transition-shadow">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center shrink-0">
                <i className="ri-file-chart-line text-secondary-600 w-full h-full flex items-center justify-center text-lg" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-foreground-800 font-heading">{report.title}</div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{report.description}</p>
              </div>
            </div>

            <div className="flex items-center justify-between text-xs mb-3">
              <span className="text-foreground-400">Última geração:</span>
              <span className="text-foreground-600 font-medium">{report.lastGenerated || "Nunca gerado"}</span>
            </div>

            <div className="mb-3">
              <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full ${
                report.status === "disponível" ? "bg-primary-50 text-primary-700" :
                report.status === "gerando" ? "bg-caution-50 text-caution-700" :
                "bg-background-100 text-foreground-500"
              }`}>
                {report.status === "disponível" ? "Disponível" : report.status === "gerando" ? "Gerando..." : "Pendente"}
              </span>
              <span className="ml-1.5 text-[10px] text-foreground-400">{report.format}</span>
            </div>

            <div className="flex items-center gap-2 pt-3 border-t border-background-100">
              <button className="flex-1 px-3 py-1.5 text-xs font-semibold text-white bg-primary-500 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap">
                <i className="ri-play-circle-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Gerar
              </button>
              {report.status === "disponível" && (
                <>
                  <button className="px-3 py-1.5 text-xs font-semibold text-accent-700 bg-accent-50 rounded-md hover:bg-accent-100 transition-colors whitespace-nowrap">
                    <i className="ri-eye-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                    Visualizar
                  </button>
                  <button className="px-3 py-1.5 text-xs font-semibold text-foreground-600 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap">
                    <i className="ri-download-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                    Exportar
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}